/**
 * Given a task item, returns the name of the task item as displayed to the student.
 * The name is just the task item index.
 */
import { parseTaskItemID } from './task';

export function getQuizTaskItemName(item) {
    if (!item) {
        return -1;
    }
    return parseTaskItemID(item.get('id')).taskItemIndex;
}

export const QUIZ_TASK_TYPES = ['INDY_QUIZ', 'PROTOTYPE_ASSESSMENTS'];

export function isQuizTask(task) {
    return task && QUIZ_TASK_TYPES.indexOf(task.get('task_type')) !== -1;
}
